<template>
  <router-view/>
</template>

<style>
/* エレメント */
img {
  max-width: 80%;
  height: auto;
  padding-top: 20px;
}
.event-logo {
  display: block;
  width: 100vw;
  max-width: none;
  height: auto;
  margin: 0 0 0 calc(50% - 50vw);
  padding-top: 0;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
h1,h2,h3,h4,h5 {
  margin: 0;
  color: dimgray;
}
h5 {
  color: darkgray;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
